import React from 'react'
import { TableColumn } from 'scenes/Dashboard/components-next/Table'
import { makeStyles } from 'tss-react/mui'

import SectionLoading from '../../../../components/SectionLoading'
import { useSubspaceListViewStore } from './SubspaceListViewStore'
import { SubspaceTable } from '../../components/SubspaceTable'
import { Subspace } from '../../../../../../entities-next/subspace'

export type SubspaceListViewContentProps = {
  className?: string
}

export function SubspaceListViewContent({ className }: SubspaceListViewContentProps) {
  const {
    state: { status, data = [], currentPage, isPreviousData, limit },
    actions: { goToPage },
  } = useSubspaceListViewStore()
  const { classes } = useStyles()
  const isLoading = status === 'loading' || isPreviousData

  return (
    <div className={className}>
      {isLoading && <SectionLoading className={classes.loading} />}
      <SubspaceTable
        data={data}
        currentPage={currentPage}
        limit={limit}
        onChangePage={goToPage}
        extraColumns={actionsRow}
      />
    </div>
  )
}

const actionsRow: TableColumn<Subspace>[] = []

const useStyles = makeStyles()({
  content: {
    position: 'relative',
  },
  loading: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255,255,255,0.5)',
  },
})
